import { cva } from '@/styled-system/css';

export const verticalNavItemRecipe = cva({
  base: {
    'display': 'block',
    'width': '100%',
    'textAlign': 'left',
    'overflow': 'hidden',
    'textStyle': 'body',
    'borderRadius': 'obj.default',
    'boxShadow': {
      base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color)',
    },
    'boxShadowColor': {
      base: 'transparent.invisible',
    },
    '& > button, & > a': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      gap: 'tighter',
      textDecoration: 'none',
      paddingBlock: 'tight',
      paddingInline: 'tight',
    },
    '&:has(> button:focus-visible), &:has(> a:focus-visible)': {
      boxShadow: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
    },
  },
  variants: {
    disabled: {
      true: {
        'opacity': 'disabled',
        'cursor': { _hover: 'default' },
        '& > a, & > button': {
          pointerEvents: 'none',
        },
      },
      false: {
        '& > button, & > a': {
          cursor: { _hover: 'pointer' },
        },
      },
    },
    selected: {
      true: {
        '& > button, & > a': {
          fontWeight: 'bold',
        },
      },
      false: {},
    },
    current: {
      page: {},
      step: {},
      location: {},
      date: {},
      time: {},
      true: {},
      false: {},
    },
    tone: {
      brand: {
        'backgroundColor': {
          base: 'bg.invisible',
        },
        '& > button, & > a': {
          color: {
            base: 'text.neutral',
          },
        },
      },
      neutral: {
        'backgroundColor': {
          base: 'bg.invisible',
        },
        '& > button, & > a': {
          color: {
            base: 'text.neutral',
          },
        },
      },
    },
  },
  compoundVariants: [
    {
      tone: 'brand',
      disabled: false,
      css: {
        'backgroundColor': {
          _focusVisible: 'bg.action.neutral.alt.hover',
          _hover: 'bg.action.neutral.alt.hover',
          _active: 'bg.action.neutral.alt.pressed',
        },
        '& > button, & > a': {
          color: {
            _hover: 'text.neutral',
            _visited: 'text.neutral',
            _active: 'text.neutral',
            _focusVisible: 'text.neutral',
          },
        },
      },
    },
    {
      tone: 'neutral',
      disabled: false,
      css: {
        'backgroundColor': {
          _hover: 'bg.action.soft.hover',
          _active: 'bg.action.soft.pressed',
          _focusVisible: 'bg.action.soft.hover',
        },
        '& > button, & > a': {
          color: {
            _hover: 'text.neutral',
            _visited: 'text.neutral',
            _active: 'text.neutral',
            _focusVisible: 'text.neutral',
          },
        },
      },
    },
    {
      selected: true,
      disabled: false,
      tone: 'brand',
      css: {
        backgroundColor: {
          base: 'bg.action.neutral.alt.pressed',
          _hover: 'bg.action.neutral.alt.pressed',
        },
      },
    },
    {
      selected: true,
      disabled: false,
      tone: 'neutral',
      css: {
        backgroundColor: {
          base: 'bg.action.soft.pressed',
          _hover: 'bg.action.soft.pressed',
        },
      },
    },
    {
      // selected state for anchors
      current: ['page', 'step', 'location', 'date', 'time', true],
      tone: 'brand',
      css: {
        'backgroundColor': {
          base: 'bg.action.neutral.alt.pressed',
          _hover: 'bg.action.neutral.alt.pressed',
        },
        '& > button, & > a': {
          fontWeight: 'bold',
        },
      },
    },
    {
      current: ['page', 'step', 'location', 'date', 'time', true],
      tone: 'neutral',
      css: {
        'backgroundColor': {
          base: 'bg.action.soft.pressed',
          _hover: 'bg.action.soft.pressed',
        },
        '& > button, & > a': {
          fontWeight: 'bold',
        },
      },
    },
  ],
});
